import api from './api';

export const sickLeaveService = {
    // Issue sick leave certificate
    issueCertificate: async (data) => {
        try {
            const response = await api.post('/sick-leave', data);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to issue certificate');
        }
    },

    // Get certificates
    getCertificates: async (filters = {}) => {
        try {
            const params = new URLSearchParams(filters);
            const response = await api.get(`/sick-leave?${params}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to fetch certificates');
        }
    },

    // Get single certificate
    getCertificate: async (certificateId) => {
        try {
            const response = await api.get(`/sick-leave/${certificateId}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to fetch certificate');
        }
    },

    // Update certificate
    updateCertificate: async (certificateId, data) => {
        try {
            const response = await api.put(`/sick-leave/${certificateId}`, data);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to update certificate');
        }
    },

    // Delete certificate
    deleteCertificate: async (certificateId) => {
        try {
            const response = await api.delete(`/sick-leave/${certificateId}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to delete certificate');
        }
    }
};
